export default __webpack_public_path__ + "static/banner_connpass_20230912-1519e726978e54b54edb19ce46cf62ee.png";